import { useStores } from '@/hooks/use-stores';

import { Entity } from '../../../NodeWidget.types';
import { areArraysEqual, buildPhysicalSchema } from '../../EditAssetDrawer.utils';

export const useInitialValues = (entity: Entity) => {
  const { pidEditStore, devicesStore } = useStores();
  const { name, deviceId, deviceModelId, controllerId } = entity;
  const connectTo = pidEditStore.getDraftDeviceWithoutPipesByIdToDevices(deviceId);
  const connectFrom = pidEditStore.getDraftDeviceWithoutPipesByIdFromDevices(deviceId);

  return {
    name,
    deviceModelId,
    controllerId: controllerId ?? devicesStore.getDeviceControllerId(deviceId),
    connectTo,
    connectFrom,
  };
};

export const mapFormValuesToPayload = (values, entity, initialValues) => ({
  name: values.name,
  deviceModelId: values.deviceModelId,
  controllerId: values.controllerId,
  ...(!entity?.deviceId && { deviceType: entity.deviceType }),
  ...(entity?.deviceId
    ? !areArraysEqual(initialValues.connectTo, values.connectTo) && {
        physicalSchema: buildPhysicalSchema(entity, {
          toDevices: values.connectTo,
        }),
      }
    : {
        to: values.connectTo,
        from: values.connectFrom,
      }),
});
